import { getCookie, CHINA_MODE_COOKIE_KEY } from 'utils/CookieUtil';

export const isChinaUser = () => {
    const cookieIsChinaMode = getCookie(CHINA_MODE_COOKIE_KEY) === 'true';
    return (
        cookieIsChinaMode ||
        // @ts-ignore
        window.chinaMode ||
        window.location.href.indexOf('garmin.cn') !== -1 ||
        window.location.href.indexOf('chinaMode=true') !== -1
    );
};

export const isCDCUser = () => {
    const cookieIsChinaMode = getCookie(CHINA_MODE_COOKIE_KEY) === 'true';

    return (
        cookieIsChinaMode ||
        // @ts-ignore
        window.chinaMode ||
        (window.location.href.indexOf('garmin.cn') !== -1 && window.location.href.indexOf('connectus.garmin.cn') === -1)
    );
};
